import { environment } from 'src/environments/environment';

const programGroupData = {
  '2022-2023': [
    {
      id: 'faith',
      displayName: 'Faith',
      icon: 'faith.jpg',
      director: {
        name: 'Tony Offenberger',
      }
    },
    {
      id: 'family',
      displayName: 'Family',
      icon: 'family.jpg',
      director: {
        name: 'Joseph Hartle',
      }
    },
    {
      id: 'community',
      displayName: 'Community',
      icon: 'community.jpg',
      director: {
        name: 'Duane Bassett',
      }
    },
    {
      id: 'life',
      displayName: 'Life',
      icon: 'life.jpg',
      director: {
        name: 'Chris Bercaw',
      }
    },
    {
      id: 'membership',
      displayName: 'Membership',
      icon: '',
      director: {
        name: 'Michael Freil',
      }
    }
  ],
  '2023-2024': [
    {
      id: 'faith',
      displayName: 'Faith',
      icon: 'faith.jpg',
      director: {
        name: 'Mark Kahanca',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Chaplain/Spiritual Advisor of the Year (50 points)',
        'Grand Knight Youth Compliancy by October 1 (25 points)'
      ]
    },
    {
      id: 'family',
      displayName: 'Family',
      icon: 'family.jpg',
      director: {
        name: 'Tim Mangan',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Family of the Year (50 points)',
        'Family Director Youth Compliancy by October 1 (25 points)'
      ]
    },
    {
      id: 'community',
      displayName: 'Community',
      icon: 'community.jpg',
      director: {
        name: 'Joseph Hartle',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Youth of the Year (50 points)',
        'Community Director Youth Compliancy by October 1 (25 points)'
      ]
    },
    {
      id: 'life',
      displayName: 'Life',
      icon: 'life.jpg',
      director: {
        name: 'Stewart Vetter',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Knight of the Year (50 points)',
        'Program Director Youth Compliancy by October 1 (25 points)'
      ]
    },
    {
      id: 'membership',
      displayName: 'Membership',
      icon: '',
      director: {
        name: 'Andrew Nuckols',
      },
      requirements: [
        '2 Growth Drives (25 points each)',
        '1 In-Person Exemplification of Charity, Unity, and Fraternity (25 points)',
        'Conduct a Fraternal Benefits Night (25 points)',
        'Attain Council Growth Percentage (0 to 100 points)'
      ]
    }
  ],
  '2024-2025': [
    {
      id: 'faith',
      displayName: 'Faith',
      icon: 'faith.jpg',
      director: {
        name: 'Mark Kahanca',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Chaplain/Spiritual Advisor of the Year (50 points)',
        'Grand Knight Youth Compliancy (25 points)'
      ]
    },
    {
      id: 'family',
      displayName: 'Family',
      icon: 'family.jpg',
      director: {
        name: 'Tim Mangan',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Family of the Year (50 points)',
        'Family Director Youth Compliancy (25 points)'
      ]
    },
    {
      id: 'community',
      displayName: 'Community',
      icon: 'community.jpg',
      director: {
        name: 'Joseph Hartle',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Youth of the Year (50 points)',
        'Community Director Youth Compliancy (25 points)'
      ]
    },
    {
      id: 'life',
      displayName: 'Life',
      icon: 'life.jpg',
      director: {
        name: 'Stewart Vetter',
      },
      requirements: [
        'At least 2 Faith in Action Activities (25 points each, max 100 total)',
        'At least 1 Council Elective Activity (25 points each, max 75 total)',
        '  *NOTE* - Faith in Action plus Council Elective max out at 125 total',
        'Knight of the Year (50 points)',
        'Program Director Youth Compliancy (25 points)'
      ]
    },
    {
      id: 'membership',
      displayName: 'Membership',
      icon: '',
      director: {
        name: 'Andrew Nuckols',
      },
      requirements: [
        '2 Growth Drives (25 points each)',
        '1 In-Person Exemplification of Charity, Unity, and Fraternity (25 points)',
        'Conduct a Fraternal Benefits Night (25 points)',
        'Attain Council Growth Percentage (0 to 100 points)'
      ]
    }
  ],
  '2025-2026': [
    {
      id: 'faith',
      displayName: 'Faith',
      totalPoints: 100,
      icon: 'faith.svg',
      director: {
        name: 'Chris Crum',
      },
      requirements: [
        'Chaplain/Spiritual Advisor of the Year (20 points)',
        'At least 2 Faith in Action Activities (20 points each, max 80 total)',
        'Up to 2 Council Choice Activities (20 points each, max 40 total)',
        '-- Faith in Action plus Council Choice max out at 80 total',
        '-- 🏅 Supreme Featured Programs are worth 40 points',
      ]
    },
    {
      id: 'family',
      displayName: 'Family',
      totalPoints: 100,
      icon: 'family.svg',
      director: {
        name: 'Michael Freil',
      },
      requirements: [
        'Family of the Year (20 points)',
        'At least 2 Faith in Action Activities (20 points each, max 80 total)',
        'Up to 2 Council Choice Activities (20 points each, max 40 total)',
        '-- Faith in Action plus Council Choice max out at 80 total',
        '-- 🏅 Supreme Featured Programs are worth 40 points',
      ]
    },
    {
      id: 'community',
      displayName: 'Community',
      totalPoints: 100,
      icon: 'community.svg',
      director: {
        name: 'Matt Smith',
      },
      requirements: [
        'Youth of the Year (20 points)',
        'At least 2 Faith in Action Activities (20 points each, max 80 total)',
        'Up to 2 Council Choice Activities (20 points each, max 40 total)',
        '-- Faith in Action plus Council Choice max out at 80 total',
        '-- 🏅 Supreme Featured Programs are worth 40 points',

      ]
    },
    {
      id: 'life',
      displayName: 'Life',
      totalPoints: 100,
      icon: 'life.svg',
      director: {
        name: 'Mike Incorvati',
      },
      requirements: [
        'Knight of the Year (20 points)',
        'At least 2 Faith in Action Activities (20 points each, max 80 total)',
        'Up to 2 Council Choice Activities (20 points each, max 40 total)',
        '-- Faith in Action plus Council Choice max out at 80 total',
        '-- 🏅 Supreme Featured Programs are worth 40 points',
      ]
    },
    {
      id: 'membership',
      displayName: 'Membership',
      totalPoints: 200,
      icon: 'membership.svg',
      director: {
        name: 'Mark Kosobud',
      },
      requirements: [
        '1 Growth Drive & Recruit a Member (20 points)',
        '1 Council Choice & Recruit a Member (20 points)',
        '1 In-Person Exemplification of Charity, Unity, and Fraternity (20 points)',
        'Participate in 2 Fraternal Benefits Nights (20 points each)',
        'Attain Council Growth Percentage by May 1 (0 to 100 points)'
      ]
    },
    {
      id: 'administrative',
      displayName: 'Administrative',
      totalPoints: 200,
      icon: 'administrative.svg',
      requirements: [
        '185 Report (25 points)',
        '365 Report (25 points)',
        'Pay State Per Capita (25 points)',
        '1295 Semi-Annual Audit Report (August) (25 points)',
        'OSC Matching Funds (25 points)',
        '1728 Annual Fraternal Survey (25 points)',
        'Youth Compliance (25 points)',
        '1295 Semi-Annual Audit Report (February) (25 points)',
      ]
    }
  ]
};

const activities: ActivityType[] = [
  {id: 'faith-of-the-year', name: 'Chaplain or Spiritual Advisor of the Year', programGroupId: 'faith'},
  {id: 'faith-faith-in-action', name: 'Faith in Action - Faith', programGroupId: 'faith'},
  {id: 'faith-council-choice', name: 'Council Choice - Faith', programGroupId: 'faith'},
  {id: 'family-of-the-year', name: 'Family of the Year', programGroupId: 'family'},
  {id: 'family-faith-in-action', name: 'Faith in Action - Family', programGroupId: 'family'},
  {id: 'family-council-choice', name: 'Council Choice - Family', programGroupId: 'family'},
  {id: 'community-of-the-year', name: 'Youth of the Year', programGroupId: 'community'},
  {id: 'community-faith-in-action', name: 'Faith in Action - Community', programGroupId: 'community'},
  {id: 'community-council-choice', name: 'Council Choice - Community', programGroupId: 'community'},
  {id: 'life-of-the-year', name: 'Knight of the Year', programGroupId: 'life'},
  {id: 'life-faith-in-action', name: 'Faith in Action - Life', programGroupId: 'life'},
  {id: 'life-council-choice', name: 'Council Choice - Life', programGroupId: 'life'},
  {id: 'membership-growth-drive', name: 'Conduct a Membership Drive', programGroupId: 'membership'},
  {id: 'membership-exemplification', name: 'In-Person Exemplification of CUF', programGroupId: 'membership'},
  {id: 'membership-benefits-night', name: 'Fraternal Benefits Night', programGroupId: 'membership'},
  {id: 'membership-council-choice', name: 'Council Choice - Membership', programGroupId: 'membership'},
  {id: 'membership-growth-percentage', name: 'Council Growth Percentage', programGroupId: 'membership'},
];

export interface ProgramGroup {
  id: string;
  displayName: string;
  totalPoints?: number;
  icon: string;
  director?: Director;
  requirements?: string[];
}

export interface ActivityType {
  id: string;
  name: string;
  programGroupId: string;
}

export interface Director {
  name: string;
}

export class ProgramGroupData {
  static programGroups: ProgramGroup[] = programGroupData[environment.fraternalYear];
  static activityTypes: ActivityType[] = activities;
}
